var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryAsset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 36,
    height: 28,
    transform: "rotate(-90 0 36)",
    fill: "url(#pattern0_223_1118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_223_1118",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_223_1118",
    transform: "matrix(0.0117845 0 0 0.0151515 -0.00673401 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_223_1118",
    width: 86,
    height: 66,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABCCAYAAADNESF6AAAACXBIWXMAAAsSAAALEgHS3X78AAADgElEQVR4nO2cQU8aQRTH/0Cr2Y0oDXoQMTYeSHpSM1+BaxO/QW89e+gH8dxT+R49+AEgaU9NbNrUSCGNbKqCS8E09IAQdNm1b3lv2JH5nchuZubxZ3fmvTdvSA0GA9RqtRyAYwBvYKFSAXCklLqcvJiqVqs5ACcA9uZh1RPhCsDLSXHTGD6pVtTZWMNQxzFpAIfzseXJcW8aTVWr1cHkhe7aOrlH56oVeq9UKiGbzZL6azabaDQaU+8VCgVsbm6S+mu32zg9PQ29v1H/SOoPAC6K5WmXD5RSnwDg2cM7f58vkwcxnfWfbMLmRh8CwnJTr9eRyWRIbXq9npA10/FXd9n7DAi75LdZB/B9n7W/RqMROk3E5ezVW9b+gKnCXrMPsogEhN358p7cicQvbjoBYd3r7/Ow47+R8AokEF+8uN0tCQqFArnNY/aJC8uNxOJFfQNGdkRhnLDGTgWtramOr4VIQNiQiMJCJCBsqVQidxL1mpkQebXbvEERMEVY6gr+GBu1Y7IL19oqa31zOp0Oe58BYZvNJvsgnBjrFXAbfbmu4GdpSY4bgaRIFBJTQSAfa5mJCoAfAI6N82MTzmgX4VBc2O3tbTiOQ2rjeR48zxOyKIhASLsn7m45jkP2NCRW6Si0LF7c7hY3xoa03HieR34CJVZp3eNpETbpSDzNxi1eEgEC4/b3GPHIy4TFi3H7e0xA2JWVFfIgliDGeQV9dxV9l2Zj5rYXWa0jgXFJGFMQT8Jwu1tL/jV77YOWSpikIxEgfFXvyHY89uOKh7T5fD7WvK0zSKDO2UAMYbkXr263S26je2smc8s/nvhUcH5+Lj3EzEh4DNYrEEJ8B2Htooal3m9Sm5vVXZGVOgwtJUbcpfK5Vi1GoV1Zq7Ba8rFJL5W3+dg7/rj0p6G//ELAknCMzMf+2nktPcTMGJmP5UYiHyuB+OGOBeWzPdzBS3jBBneugJuEewUflFIngIZcgeu6sco4+/0+qx1RaAkQuEPaYrHIerjDVhsKkfCpYExa62gLhBVWCOMCBAm0hLSLeLhDyxkEbnfLegULjJHZLd1uThwkbLRegRDikZcJIa2WMs5vN/QvFFX9yr14SUReWso4k77nZQrGJbol3C2JHWF7MpERpVRq9DmNYdbbMjv3dEwDOAJwNh9bngxXGOo4Jn33n6f7sE9uXCoA9h/+Me8/wh3Jz5Vrme0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryAsset);
export default __webpack_public_path__ + "static/media/library_asset.e8c899567d1c63b1ef58f7395b15b281.svg";
export { ForwardRef as ReactComponent };